import { withApollo } from "react-apollo";
import BookingEventDetails from "./BookingEventDetails";
import CheckInRequired from "./CheckInRequired";
import EquipmentDetails from "./EquipmentDetails";

const PopoverBookingStatusDetail = ({
  data,
  equipmentDetails = false,
  client,
  onUpdateComplete,
  onAssistanceUpdateStarted,
  onAssistanceUpdateComplete,
  assistanceUpdateCallbackRef,
  allowAssistanceEdit = false,
  startLoading,
  stopLoading
}) => {
  const eventData = data?.eventData;
  const checkInRequired = eventData?.checkInRequired;
  return (
    <div style={{ padding: "0 1rem" }}>
      <CheckInRequired eventData={eventData} show={checkInRequired} />

      <BookingEventDetails key={data?.eventData?.bookingId || data?.eventData?.id || data?.eventData?.entryId}
        eventData={data?.eventData}
        equipments={equipmentDetails}
        client={client}
        onUpdateComplete={onUpdateComplete}
        onAssistanceUpdateStarted={onAssistanceUpdateStarted}
        onAssistanceUpdateComplete={onAssistanceUpdateComplete}
        assistanceUpdateCallbackRef={assistanceUpdateCallbackRef}
        allowAssistanceEdit={allowAssistanceEdit}
        startLoading={startLoading}
        stopLoading={stopLoading}
      />

      <EquipmentDetails
        show={equipmentDetails}
        equipmentData={data?.equipmentData}
      />
    </div>
  );
};

export default withApollo(PopoverBookingStatusDetail);
